import ReportTemplateRow from './ReportTemplateRow';

export default ReportTemplateRow;
